import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import { ClientRecordTemplate, ClientRecordTemplateSchema } from "./clientRecordTemplateService";

const api = new APIClient();

const PRESET_RESOURCE = "/client-record-template-presets";
const TEMPLATE_RESOURCE = "/client-record-templates";

export type ClientRecordTemplatePresetType = "anamnesis" | "evolution";

export interface ClientRecordTemplatePreset {
  id: number;
  slug: string;
  title: string;
  specialty: string;
  record_type?: ClientRecordTemplatePresetType;
  schema_json: ClientRecordTemplateSchema;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface ClientRecordTemplatePresetListParams extends PaginationParams {
  specialty?: string;
  record_type?: ClientRecordTemplatePresetType;
}

export const getPresets = (
  params?: ClientRecordTemplatePresetListParams
): Promise<PaginatedApiResponse<ClientRecordTemplatePreset>> =>
  api.get<PaginatedApiResponse<ClientRecordTemplatePreset>>(
    PRESET_RESOURCE,
    params
  );

export const copyFromPreset = (
  presetId: number
): Promise<ApiResponse<ClientRecordTemplate>> =>
  api.create<ApiResponse<ClientRecordTemplate>>(
    `${TEMPLATE_RESOURCE}/from-preset/${presetId}`,
    {}
  );
